import { render, staticRenderFns } from "./edit-personal-policy-form.vue?vue&type=template&id=2c6747a7&scoped=true&"
import script from "./edit-personal-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-personal-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6747a7",
  null
  
)

export default component.exports